import { render, staticRenderFns } from "./MerchantAlertSettings.vue?vue&type=template&id=4419c78b&scoped=true"
import script from "./MerchantAlertSettings.vue?vue&type=script&lang=js"
export * from "./MerchantAlertSettings.vue?vue&type=script&lang=js"
import style0 from "./MerchantAlertSettings.vue?vue&type=style&index=0&id=4419c78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4419c78b",
  null
  
)

export default component.exports